import { useSyncExternalStore } from 'react';
import { assinarPersonificacao, obterPersonificacao, type Personificacao } from '@/data/personificacao';

/** Reage a mudanças de personificação (banner, dropdown) sem prop drilling. */
export function usePersonificacao(): Personificacao | null {
  return useSyncExternalStore(assinarPersonificacao, obterPersonificacao);
}
